export default __webpack_public_path__ + "static/tag-dont-2-dark-7a3addb2cdb2785d6d36bd6c3276b0efc515d332e8e0c564fc4ff44ca0bd43c8.png";